import { observer } from 'mobx-react';
import { Box, Grid, Typography, Button } from '@material-ui/core';
import {
  createNumberFormatField, SelectField, createTextField,
} from '@roc/ui';
import { bankInformationPropertyStates, isNotBlank } from '@roc/feature-utils';
import { Tooltip } from '@roc/ui';
import HelpIcon from '@material-ui/icons/Help';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useLoanVendorStore } from '../../hooks/userLoanVendorStore';
import { LoanVendorSearchBar } from '../loan/loanVendorSearchBar';
import { useEffect } from 'react';
import { CounterPartyExpensesTab } from '../../types/types';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      padding: '10px',
      paddingTop: '20px',
      paddingBottom: '20px',
    },
    field: {
      padding: '10px',
    },
    button: {
      width: '160px',
      marginTop: '10px',
      marginRight: '10px',
    },
  };
});

export const CreateVendorForm = observer(() => {
  const { loanVendorStore } = useLoanVendorStore();
  const { vendorFormStore, selectedTab } = loanVendorStore
  const classes = useStyles();

  useEffect(() => {
    vendorFormStore.reset();
    if (loanVendorStore.loanVendor && selectedTab === CounterPartyExpensesTab.VENDOR_CREATE_VENDORS) {
      loanVendorStore.loadVendorForm();
    }

  }, [loanVendorStore.loanVendor]);

  return (
    <Box>
      <Grid container direction='row' className={classes.container}>
        <Grid item sm={4} xs={12} >
          <LoanVendorSearchBar />
        </Grid>
        <Grid item xs={12} style={{ marginBottom: 24, marginTop: 16 }} >
          <Box width={"100%"} height={'1px'} bgcolor={"#ddd"} mt={1}></Box>
        </Grid>
        <Grid item xs={12} sm={6} className={classes.field}>
          {createTextField({
            label: 'Company Name',
            fieldName: 'companyName',
            testId: 'companyName',
            store: vendorFormStore,
          })}
        </Grid>
        <Grid item xs={12} sm={6} className={classes.field}>
          {createTextField({
            label: 'Alias',
            fieldName: 'alias',
            testId: 'alias',
            store: vendorFormStore,
          })}
        </Grid>
        <Grid item xs={12} sm={6} className={classes.field}>
          {createTextField({
            label: 'Street Name',
            fieldName: 'streetName',
            testId: 'streetName',
            store: vendorFormStore,
          })}
        </Grid>
        <Grid item xs={12} sm={6} className={classes.field}>
          {createTextField({
            label: 'City',
            fieldName: 'city',
            testId: 'city',
            store: vendorFormStore,
          })}
        </Grid>
        <Grid item xs={12} sm={6} className={classes.field}>
          {createTextField({
            label: 'Zip Code',
            fieldName: 'zipCode',
            testId: 'zipCode',
            store: vendorFormStore,
          })}
        </Grid>
        <Grid item xs={12} sm={6} className={classes.field}>
          <SelectField
            standaloneLabel
            label={'State'}
            name={'state'}
            value={vendorFormStore.form.fields.state.value}
            error={isNotBlank(
              vendorFormStore.form.fields.state.error
            )}
            errorText={
              vendorFormStore.form.fields.state.error
            }
            options={bankInformationPropertyStates.map(s => ({ label: s.label, value: s.id }))}
            onChange={label =>
              vendorFormStore.onFieldChange('state', label)
            }
            variant="outlined"
            fullWidth
            shrink
            testId="state"
          />
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => loanVendorStore.saveVendor()}
            >
              {loanVendorStore.loanVendor ? "Update Vendor" : "Create Vendor"}
            </Button>
          </Box>
        </Grid>
      </Grid>

    </Box>

  )
});